export const ROUTE_SLUGS = {
  id: ":id",
  category_id: ":category_id",
  authType: ":authType",
  orderId: ":orderId",
  code: ":code",
};

export const SEARCH_PARAMS = {
  categoryId: "categoryId",
  division: "division",
  query: "query",
};

export const ALL_PRODUCTS = "ALL";

export const ROUTES = {
  HOME: "/",
  DIVISION_ID: `/division/${ROUTE_SLUGS.id}`,
  OVERVIEW: "overview",
  ABOUT: "/about",
  SHOP: "/our-shop",
  SHOP_CATEGORY_ID: `/our-shop/${ROUTE_SLUGS.category_id}`,
  SHOP_ID: `/our-shop/${ROUTE_SLUGS.id}`,
  SHOP_CATEGORY_PRODUCT_ID: `/our-shop/${ROUTE_SLUGS.category_id}/${ROUTE_SLUGS.code}`,
  CART: "/cart",
  AUTH_TYPE: `/auth/${ROUTE_SLUGS.authType}`,
  YOUR_ORDERS_ID: `/your-orders/${ROUTE_SLUGS.orderId}`,
  YOUR_ORDERS: `/your-orders`,
  REGISTER: "/register",
  OUR_STORY: "/our-story",
  WISH_LIST: "/my-wish-list",
  FORGOT_PASSWORD: "/forgot-password",
  DELETE_USER: "/delete-user",
  PRIVACY_POLICY: "/privacy-policy",
};

export const screenNames = {
  home: "Home",
  productsList: "Products List",
  productDetail: "Product Detail",
  wishList: "Wish List",
  cart: "Cart",
  orders: "Orders Group",
  orderList: "Order List",

  signin: "Signin",
  signup: "Signup",
  auth: "Authentication",

  otp: "OTP",
  resetPassword: "Reset Password",
  splash: "Splash",

  SearchPage: "SearchPage",

  splashPage: "Splash Page",
  EditProfile: "EditProfile",
  EditPersonalDetails: "EditPersonalDetails",
  EditBusinessDetails: "EditBusinessDetails",
  EditPassword: "EditPassword",
  EditMobile: "EditMobile",
  AboutUs: "AboutUs",
  PrivacyPolicy: "Privacy Policy",
  ShareApp: "ShareApp",
  DivisionPage: "DivisionPage",
  termsAndConditions: "TermsAndConditions",
};
